import { useEffect, useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Users, ArrowLeft, IdCard } from 'lucide-react';
import { cpdAPI, errMsg } from '../../lib/cpdRegisterAPI';
import { CPDStatusBadge, STATUS } from './CPDStatus';
import { CPDDashboardTab } from './CPDDashboardTab';
import { CPDActivitiesTab } from './CPDActivitiesTab';
import { CPDRegistrationsDialog } from './CPDRegistrationsDialog';
import { toast } from 'sonner';

export const CPDTeamTab = ({ me, onOpen, onAddFor, refreshKey }) => {
  const [team, setTeam] = useState([]);
  const [staff, setStaff] = useState([]);
  const [sel, setSel] = useState(null);
  const [reg, setReg] = useState(null);
  const load = () => Promise.all([cpdAPI.team(), cpdAPI.staff()]).then(([t, s]) => { setTeam(t.items); setStaff(s.items); }).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [refreshKey]);
  const counts = {};
  team.forEach((m) => m.frameworks.forEach((f) => { counts[f.status] = (counts[f.status] || 0) + 1; }));
  if (sel) {
    return (
      <div className="space-y-6">
        <Button variant="ghost" onClick={() => setSel(null)} data-testid="cpd-team-back"><ArrowLeft className="w-4 h-4 mr-1" /> Team</Button>
        <CPDDashboardTab userId={sel.user_id} me={me} title={sel.name} refreshKey={refreshKey} onAdd={me.tier === 'admin' ? () => onAddFor(sel.user_id) : null} />
        <CPDActivitiesTab me={me} userId={sel.user_id} onOpen={onOpen} refreshKey={refreshKey} />
      </div>
    );
  }
  const withFw = new Set(team.map((m) => m.user_id));
  return (
    <div className="space-y-5" data-testid="cpd-team-tab">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {Object.keys(STATUS).map((s) => (
          <Card key={s}><CardContent className="py-3"><CPDStatusBadge status={s} /><p className="text-2xl font-bold mt-1" data-testid={`cpd-team-count-${s}`}>{counts[s] || 0}</p></CardContent></Card>))}
      </div>
      <Card className="overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Staff</TableHead><TableHead>Role</TableHead><TableHead>Framework status</TableHead><TableHead /></TableRow></TableHeader>
          <TableBody>
            {staff.map((s) => {
              const t = team.find((m) => m.user_id === s.user_id);
              return (
                <TableRow key={s.user_id} data-testid={`cpd-team-row-${s.user_id}`}>
                  <TableCell><p className="font-medium">{s.name}</p><p className="text-xs text-muted-foreground">{s.email}</p></TableCell>
                  <TableCell className="text-sm">{s.employment_role || '—'}</TableCell>
                  <TableCell><div className="flex flex-col gap-1">{t ? t.frameworks.map((f) => (
                    <span key={f.user_framework_id} className="flex items-center gap-2 text-xs">{f.framework_name}: <CPDStatusBadge status={f.status} /> {f.counted}/{f.required} h</span>))
                    : <span className="text-xs text-muted-foreground">No frameworks assigned</span>}</div></TableCell>
                  <TableCell className="text-right whitespace-nowrap">
                    {withFw.has(s.user_id) && <Button size="sm" variant="outline" onClick={() => setSel(s)} data-testid={`cpd-team-view-${s.user_id}`}><Users className="w-4 h-4 mr-1" />View</Button>}
                    {me.tier === 'admin' && <Button size="sm" variant="ghost" onClick={() => setReg(s)} data-testid={`cpd-team-reg-${s.user_id}`}><IdCard className="w-4 h-4 mr-1" />Registrations</Button>}
                  </TableCell>
                </TableRow>);
            })}
          </TableBody>
        </Table>
      </Card>
      <CPDRegistrationsDialog person={reg} onClose={() => { setReg(null); load(); }} />
    </div>
  );
};
